<div class="layout-container">
    <h2 class="heading-lg">Services Offer</h2><hr>
    <p class="text-block">
        Our company is a leading name in the manufacture and supply of various plastic Mold & products. 
        Our product line embodies High Quality Precision molded plastic components for Automotive, Electronics, Electrical, Food & Beverage, 
        Pharmaceutical & Household industry. Services we offer to our customers are:
    
    </p>
    <ul class="custom-bullet-list">
        <li>Insert Molding</li>
        <li>Hot & Cold Runner Injection Molding</li>
        <li>On-site mold maintenance and development of Tools & Dies</li>
        <li>Original equipment manufacturer (OEM)</li>
        <li>Multi component & Sub Assembly</li>
        <li>In-house Pad Printing facility</li>
        <li>Ultrasonic Welding</li>
        <li>Shrink Packing or Normal Packing of Finished Goods</li>
        <li>End-to-End Contract Manufacturing</li>
        <li>3D Printing</li>
        <li>Rapid Prototyping</li>
      </ul>
    </div>
    
